module.exports = __webpack_public_path__ + "static/media/kehu-al2.a66c9bfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageIntelligentDataSecurityGateway/kehu-al2.png
// module id = 638
// module chunks = 0